const DEFAULT_SYSTEM_ADMIN_SESSION_MAX_SECONDS = 8 * 60 * 60

const DEFAULT_USER_SESSION_MAX_SECONDS = 24 * 60 * 60

const DEFAULT_SESSION_COUNTDOWN_SECONDS = 10 * 60

const env = <const>{
  apiUrl: process.env.REACT_APP_API_URL || '',
  appIdentifier: process.env.REACT_APP_APP_IDENTIFIER || '',
  firebaseConfig: process.env.REACT_APP_FIREBASE_CONFIG || '{}',
  appUrl: process.env.REACT_APP_URL || '',
  globalworthUrl: process.env.REACT_APP_GLOBALWORTH_URL || '',
  appAndroidPackageName: process.env.REACT_APP_ANDROID_PACKAGE_NAME || '',
  appIosBundleId: process.env.REACT_APP_IOS_BUNDLE_ID || '',
  productFlavor: process.env.REACT_APP_PRODUCT_FLAVOR || '',
  continueUrlRedirect: process.env.REACT_APP_CONTINUE_URL_REDIRECT || true,
  firebaseAppCheckDebug: process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG || null,
  firebaseAppCheckSiteKey:
    process.env.REACT_APP_FIREBASE_APPCHECK_SITE_KEY || null,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  googleCalendarApiScopes:
    process.env.REACT_APP_GOOGLE_CALENDAR_API_SCOPES || '',
  testMode: process.env.REACT_APP_TEST_MODE === 'true' || false,
  hideMicrosoftAuth:
    process.env.REACT_APP_HIDE_MICROSOFT_AUTH === 'true' || false,
  hideTwoFactorAuth:
    process.env.REACT_APP_HIDE_TWO_FACTOR_AUTH === 'true' || false,
  batchAddUsersLimit: process.env.REACT_APP_BATCH_ADD_USERS_LIMIT || '-1',
  systemAdminSessionMaxSeconds:
    Number(process.env.REACT_APP_SUPER_ADMIN_SESSION_MAX_SECONDS) ||
    DEFAULT_SYSTEM_ADMIN_SESSION_MAX_SECONDS,
  userSessionMaxSeconds:
    Number(process.env.REACT_APP_USER_SESSION_MAX_SECONDS) ||
    DEFAULT_USER_SESSION_MAX_SECONDS,
  sessionCountdownSeconds:
    Number(process.env.REACT_APP_SESSION_COUNTDOWN_SECONDS) ||
    DEFAULT_SESSION_COUNTDOWN_SECONDS,
}

const optionalKeysByFlavor: Partial<Record<string, (keyof typeof env)[]>> = {
  // Only the Blue Bolt app sends users on to the Globalworth app
  globalworth: ['globalworthUrl'],
}

const optionalKeys: readonly string[] =
  optionalKeysByFlavor[env.productFlavor] ?? []

Object.entries(env).forEach(([key, value]) => {
  if (!value && !optionalKeys.includes(key)) {
    console.error(`Missing ${key} env variable.`)
  }
})

export default env
